import { selectAll } from "./functionAux";

const selectCategoryPosts = () => {
    const btnCategories = selectAll('li[data-categoria]');
    const allPosts = selectAll('.item-preview-post');

    function showHiddenPosts() {
        const category = this.getAttribute('data-categoria');
        const isActive = this.classList.contains('active');

        // Remove active de todas as categorias
        btnCategories.forEach(btn => btn.classList.remove('active'));

        // Se já estava ativo, mostra todos os posts (toggle off)
        if (isActive) {
            allPosts.forEach(post => post.classList.add('active'));
            // Marca "Tudo" como ativo
            const btnAll = document.querySelector('li[data-categoria="all"]');
            btnAll?.classList.add('active');
            return;
        }

        // Adiciona active na categoria clicada
        this.classList.add('active');

        // Remove active de todos os posts
        allPosts.forEach(post => post.classList.remove('active'));

        // Adiciona active nos posts da categoria selecionada
        selectAll(`.item-preview-post.${category}`)
            .forEach(post => post.classList.add('active'));
    }

    btnCategories?.forEach(btn => btn.addEventListener('click', showHiddenPosts))
}


export default selectCategoryPosts;
